(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seu-wall-art-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  const form=document.getElementById('seu-poster-form');
  const source=document.getElementById('seu-poster-index');
  const panel=document.getElementById('seu-poster-results');
  if(!form||!source||!panel)return;
  const input=document.getElementById('seu-poster-search');
  const matches=document.getElementById('seu-poster-matches');
  const status=document.getElementById('seu-poster-status');
  const heading=document.getElementById('seu-poster-results-heading');
  const gallery=document.querySelector('.seu-poster-page__heading');
  const normalise=value=>String(value||'').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,'');
  const escapeHtml=value=>String(value||'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  async function loadIndex(){
    let items=JSON.parse(source.textContent);
    if(source.dataset.hasNext!=='true')return items;
    const section=source.dataset.section;
    for(let page=2;page<=100;page++){
      const url=new URL(window.location.pathname,window.location.origin);
      url.searchParams.set('page',String(page));
      url.searchParams.set('section_id',section);
      const response=await fetch(url.toString(),{credentials:'same-origin'});
      if(!response.ok)throw new Error('Poster catalogue unavailable');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=html.querySelector('#seu-poster-index');
      if(!next)throw new Error('Poster catalogue page missing');
      items=items.concat(JSON.parse(next.textContent));
      if(next.dataset.hasNext!=='true')return items;
    }
    throw new Error('Poster catalogue exceeds search limit');
  }
  const indexPromise=loadIndex();
  async function show(term,updateUrl){
    term=term.trim();input.value=term;
    if(!term){panel.hidden=true;gallery.hidden=false;if(updateUrl)history.replaceState(null,'',window.location.pathname);return;}
    panel.hidden=false;gallery.hidden=true;heading.textContent='Posters matching “'+term+'”';
    status.textContent='Finding poster designs…';matches.replaceChildren();
    if(updateUrl){const url=new URL(window.location.href);url.searchParams.set('car',term);history.replaceState(null,'',url);}
    try{
      const products=await indexPromise;
      const needle=normalise(term);
      const result=products.filter(item=>normalise(item.title).includes(needle)||normalise(item.tags).includes(needle));
      status.textContent=result.length?result.length+' poster designs found across the galleries.':'No matching posters yet. Try another car name or browse the galleries below.';
      for(const item of result){
        const card=document.createElement('a');card.className='seu-poster-result';card.href=item.url;
        card.innerHTML=(item.image?'<img src="'+escapeHtml(item.image)+'" alt="" loading="lazy">':'')+'<strong>'+escapeHtml(item.title)+'</strong><span>From '+escapeHtml(item.price)+'</span>';
        matches.append(card);
      }
      if(result.length===0)gallery.hidden=false;
    }catch(error){status.textContent='Poster search is unavailable right now. Browse the galleries below.';gallery.hidden=false;}
  }
  form.addEventListener('submit',event=>{event.preventDefault();show(input.value,true);});
  document.getElementById('seu-poster-clear').addEventListener('click',()=>{input.value='';show('',true);input.focus();});
  show(new URLSearchParams(window.location.search).get('car')||'',false);
})();

  } catch(e) { console.error(e); }
})();
})();
